<template>
    <v-flex :url="url">
        <a @click="$store.state.isOld = !$store.state.isOld"><h2 :class="$store.state.isOld ? 'notifications_point new': 'notifications_point'">{{ $t("Прочитанные") }}</h2></a>
        <Transition name="bounce">
            <div v-if="$store.state.isOld">
                <notificationRecord v-for="(notification, i) in readed.slice((this.paginator - 1) * 10, this.paginator * 10)" :key="i" class="notifications_block"
                                    :info="notification"
                />
                <div v-if="readed.length > 10" class="text-xs-center">
                    <v-pagination
                        v-model="paginator"
                        :length="Math.ceil(readed.length / 10)"
                        :total-visible="10"
                    />
                </div>
            </div>
        </Transition>
    </v-flex>
</template>

<script>
import {mapState, mapGetters, mapMutations} from 'vuex';
import notificationRecord from '@/components/blocks/Notifications/notification_record.vue';
import dayjs from 'dayjs';
import orderby from 'lodash.orderby';

export default {
  components: {
    notificationRecord,
  },
  data() {
    return {
      paginator: 1,
      show     : false,
    };
  },
  computed: {
    ...mapState('common', ['url']),
    ...mapGetters('notifications/Notifications_items', ['notifications']),
    readed() {
      return this.notifications.filter((x) => !x.new);
    },
  },
};
</script>

<style scoped>
a {
  color: #4a4a4a
}
</style>
